import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { getUserId } from 'utils/storage';
import { type PacksServiceTypes } from './types';

const API_URL = `${BASE_URL}packs`;

export const PacksService: PacksServiceTypes = {
  getSessionPacks: async specialityId =>
    service.get(`${API_URL}/patients/${getUserId()}/speciality/${specialityId}`),
};
